import consumer from "./consumer"

consumer.subscriptions.create(
  "WebNotificationsChannel",
  {
    received(data) {
      const notification =
        document.querySelector(".data_web_notification")

      if (data["type"] === "missing_bills_ready") {
        if (notification) {
          notification.innerHTML =
            "Your Missing Bills report is ready."

          notification.setAttribute("class", "d_link")
        }

        if (data["download_url"]) {
          const iframe = document.createElement("iframe")

          iframe.style.display = "none"
          iframe.src = data["download_url"]

          document.body.appendChild(iframe)

          setTimeout(() => {
            iframe.remove()
          }, 60000)
        }

        return
      }

      if (data["message"] && notification) {
        notification.innerHTML = data["message"]
        notification.setAttribute("class", "d_link")
      }
    }
  }
)
